export const LOAD = 'WORKERS:LOAD'
export const REFRESH = 'WORKERS:REFRESH'
export const CLEAR = 'WORKERS:CLEAR'
